import { createContext, useContext } from 'react';

export const ContactFormContext = createContext(null);

export const useContactFormConfig = () => useContext(ContactFormContext);
